import React, { useContext, useEffect, useState } from "react";
import { PartidasContext } from "../../context/PartidasContext";
import { DestajosContext } from "../../context/DestajosContext";
import EliminadoCard from "./EliminadoCard";

const EliminadosObra = ({ idProyecto, callback }) => {
  const [vista, setVista] = useState("partidas");

  const { partidasEliminadas, getPartidasEliminadas, restorePartida } =
    useContext(PartidasContext);
  const { destajosEliminados, getDestajosEliminados, restoreDestajo } =
    useContext(DestajosContext);

  useEffect(() => {
    getPartidasEliminadas(idProyecto);
    getDestajosEliminados(idProyecto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // A restored partida changes the "Partida eliminada" badge of its destajos.
  const handlePartidaRestored = () => {
    getDestajosEliminados(idProyecto);
    if (typeof callback === "function") callback();
  };

  const renderPartidas = () =>
    partidasEliminadas.map((partida) => (
      <EliminadoCard
        key={`partida-eliminada-${partida.idPartida}`}
        clave={partida.clave}
        nombre={partida.nombre}
        deletedAt={partida.deletedAt}
        eliminadoPor={partida.eliminado_por}
        comentario={partida.comentario}
        onRestore={() =>
          restorePartida(idProyecto, partida, handlePartidaRestored)
        }
      />
    ));

  const renderDestajos = () =>
    destajosEliminados.map((destajo) => (
      <EliminadoCard
        key={`destajo-eliminado-${destajo.idDestajo}`}
        clave={destajo.clave}
        nombre={destajo.nombre}
        partida={destajo.nombre_partida}
        partidaEliminada={Boolean(destajo.partida_deletedAt)}
        deletedAt={destajo.deletedAt}
        eliminadoPor={destajo.eliminado_por}
        comentario={destajo.comentario}
        onRestore={() => restoreDestajo(idProyecto, destajo, callback)}
      />
    ));

  const renderLista = () => {
    const items = vista === "partidas" ? partidasEliminadas : destajosEliminados;
    if (!Array.isArray(items)) return <div className="spinner-border" />;
    if (items.length === 0) {
      return (
        <div className="text-center text-muted py-5">
          <i className="fa fa-check-circle fa-2x mb-2 d-block" />
          No hay {vista} eliminados.
        </div>
      );
    }
    if (vista === "partidas") return renderPartidas();
    return renderDestajos();
  };

  const renderTab = (key, label, items) => (
    <button
      className={`btn btn-sm ${
        vista === key ? "btn-primary" : "btn-outline-primary"
      }`}
      onClick={() => setVista(key)}
    >
      {label}
      {Array.isArray(items) && (
        <span className="badge bg-light text-dark ms-2">{items.length}</span>
      )}
    </button>
  );

  return (
    <div>
      <div className="btn-group mb-3">
        {renderTab("partidas", "Partidas", partidasEliminadas)}
        {renderTab("destajos", "Destajos", destajosEliminados)}
      </div>
      {renderLista()}
      {vista === "destajos" && (
        <p className="small text-muted mb-0">
          Si la partida de un destajo está eliminada, restaura también la
          partida para que vuelva a aparecer en la obra.
        </p>
      )}
    </div>
  );
};

export default EliminadosObra;
